import { I18n } from '@calendly/i18n'

/**
 * Generates payment information text with optional coupon details
 * @param {Object} charge - The charge object containing payment and coupon info
 * @param {boolean} shouldShow - Whether to show payment info (hasCharge or showCharge)
 * @returns {string|null} - Formatted payment info string or null
 */
export const getPaymentInfo = (charge, shouldShow) => {
  if (!shouldShow) return null

  const hasBookingCode = charge && charge.bookingCodeInfo

  if (hasBookingCode) {
    const discountWithSymbol = charge.bookingCodeInfo.bookingCodeType === 'FIXED'
      ? charge.bookingCodeInfo.discountValueWithSymbol
      : `${charge.bookingCodeInfo.percentOff}%`

    return I18n.t('publisher.dashboard.invitee.paid_via_with_booking_code', {
      amount_with_symbol: charge.amountWithSymbol,
      currency: charge.currency,
      provider_name: charge.providerName,
      discount_with_symbol: discountWithSymbol,
    })
  }

  return I18n.t('publisher.dashboard.invitee.paid_via', {
    amount_with_symbol: charge.amountWithSymbol,
    currency: charge.currency,
    provider_name: charge.providerName
  })
}
